import { ConnectionDto, mapConnectionUIName } from "@arelia-types/connection"
import ConnectionCard from "./ConnectionCard";
import { useState } from "react";
import BasicDialog from "../dialogs/BasicDialog";
import { GoogleSigninButton } from "@arelia-components/ui-atoms/GoogleSigninButton";
import { openAuthWindow } from "../helpers";
import { Box, Button, Typography } from "@mui/material";
import { useAvailableServiceAccounts } from "../../../../api/availableServiceAccounts";

type Props = {
  connection: ConnectionDto,
}

export default function GoogleConnection({ connection }: Props) {
  const [open, setOpen] = useState<boolean>(false);
  const pagesQuery = useAvailableServiceAccounts(connection.name, {});

  return <Box>
    <ConnectionCard {...connection} onConnect={() => setOpen(true)} />
    {open && <BasicDialog
      connection={connection}
      title={`Sign in to ${connection.name}`}
      onClose={() => setOpen(false)}
      pagesQuery={pagesQuery}
      canDisconnect={true}
      showSaveButton={pagesQuery.data && pagesQuery.data.length > 0}
      renderActions={() =>
        <>{
          connection.connected
            ?
            <Button
              variant="outlined"
              onClick={() => openAuthWindow(connection.name)}
            >
              Reconnect
            </Button>
            :
            <GoogleSigninButton clicked={() => openAuthWindow(connection.name)} />
        }</>
      }
    >
      {
        !connection.connected
          ?
          <>
            <Typography>
              Please sign in to your Google account to establish connection YouTube service with Arelia
            </Typography>
            <Typography sx={{
              lineHeight: "16px",
              fontSize: "12px",
              marginTop: "10px",
              fontStyle: "italic"
            }}>
              {/* eslint-disable-next-line react/jsx-no-target-blank */}
              ARELIA’s use and transfer of information received from Google APIs to any other app will adhere to <a href="https://developers.google.com/terms/api-services-user-data-policy" target="_blank">Google API Services User Data Policy</a>, including the Limited Use requirements.
            </Typography>
          </>
          :
          <Typography>Arelia has successfully connected to {mapConnectionUIName(connection.name)} with account <b>{connection.login}</b>.
          </Typography>
      }


    </BasicDialog>}
  </Box>;
}